import { render, staticRenderFns } from "./relevanceFrom.vue?vue&type=template&id=ab96750e&scoped=true"
import script from "./relevanceFrom.vue?vue&type=script&lang=js"
export * from "./relevanceFrom.vue?vue&type=script&lang=js"
import style0 from "./relevanceFrom.vue?vue&type=style&index=0&id=ab96750e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab96750e",
  null
  
)

export default component.exports